import { ApiBind, Common } from './common.model';


export class PlatformSDKVersionGroup extends Common {
  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'platform_id' })
  platformId: number;

  @ApiBind({ column: 'platform_name' })
  platformName: string;

  @ApiBind({ column: 'ad_format' })
  adFormat: number;

  @ApiBind({ column: 'sdk_version_group_id' })
  sdkVersionGroupId: number;

  @ApiBind({ column: 'sdk_version_group_name' })
  sdkVersionGroupName: string;

  @ApiBind({ column: 'memo' })
  memo: string;

  @ApiBind({ column: 'delivery_type' })
  deliveryType: number;

  @ApiBind({ column: 'sort' })
  sort: number;

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;
}
